// src/services/companyFiles.js
const API_BASE = 'https://new.sbdemolition.online/api/company-files';

async function apiRequest(endpoint, options = {}) {
  const authToken = localStorage.getItem('authToken');
  
  const headers = {
    'Content-Type': 'application/json',
    ...(authToken && { 'Authorization': `Bearer ${authToken}` }),
    ...options.headers
  };

  const response = await fetch(`${API_BASE}${endpoint}`, {
    ...options,
    credentials: 'include',
    headers
  });

  if (response.status === 401) {
    localStorage.clear();
    window.location.href = '/login';
    throw new Error('Unauthorized');
  }

  const text = await response.text();
  
  if (text.trim().startsWith('<!DOCTYPE') || text.trim().startsWith('<html')) {
    return { success: false, error: 'Server error', data: [] };
  }

  try {
    return JSON.parse(text);
  } catch (e) {
    throw new Error('Invalid JSON response');
  }
}

export const companyFilesAPI = {
  getFiles: () => apiRequest('/list.php'),
  
  uploadFile: async (file, metadata) => {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('category', metadata.category);
    formData.append('description', metadata.description || '');

    const authToken = localStorage.getItem('authToken');
    
    // ✅ غيرت من upload-file.php لـ upload.php
    const response = await fetch(`${API_BASE}/upload.php`, {
      method: 'POST',
      credentials: 'include',
      headers: {
        'Authorization': `Bearer ${authToken}`
      },
      body: formData
    });

    const uploadResult = await response.json();
    
    if (!uploadResult.success) {
      throw new Error(uploadResult.error || 'Upload failed');
    }

    // ✅ الـ upload.php بيحفظ في الداتابيز مباشرة، مش محتاج create.php
    return uploadResult;
  },
  
  deleteFile: (id) => apiRequest(`/delete.php?id=${id}`, { method: 'DELETE' }),
  
  // ✅ استخدم download.php بدلاً من file.php
  getFileUrl: (fileId) => `${API_BASE}/download.php?id=${fileId}`
};
